import { IMappedRate } from '../interface/IRate';
import { authenticatedApi } from './api';

const getRateByDate = async (date: string) => {
  return authenticatedApi.get(`rate/date/${date}`);
};

const getRateByYear = async (year: string) => {
  return authenticatedApi.get(`rate/year/${year}`);
};

const updateAllByDate = async (rates: Partial<IMappedRate>[]) => {
  return authenticatedApi.put(`rate/update`, rates);
};

const rateApi = { getRateByDate, getRateByYear, updateAllByDate };

export default rateApi;
